'use strict';

exports.__esModule = true;
exports.CardContent = exports.CardTitle = exports.CardHeader = exports.Card = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = _styledComponents2.default.div.withConfig({
  displayName: 'Card',
  componentId: 'sc-77eb2z-0'
})(['margin:8px;background-color:#fff;color:rgba(0,0,0,0.54);box-shadow:0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12);border-radius:2px;overflow:hidden;']);

var CardHeader = _styledComponents2.default.div.withConfig({
  displayName: 'Card__CardHeader',
  componentId: 'sc-77eb2z-1'
})(['padding:16px;min-height:64px;display:flex;align-items:center;box-sizing:border-box;']);

var CardTitle = _styledComponents2.default.div.withConfig({
  displayName: 'Card__CardTitle',
  componentId: 'sc-77eb2z-2'
})(['font-size:16px;letter-spacing:0.06em;font-weight:bold;text-transform:uppercase;color:rgba(0,0,0,0.87);']);

var CardContent = _styledComponents2.default.div.withConfig({
  displayName: 'Card__CardContent',
  componentId: 'sc-77eb2z-3'
})(['padding:16px;', ' + &{padding-top:0;}'], CardHeader);

exports.Card = Card;
exports.CardHeader = CardHeader;
exports.CardTitle = CardTitle;
exports.CardContent = CardContent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/components/Card/index.js
// module id = 1063
// module chunks = 29